var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapper,{tag:"Component",staticClass:"not-found",attrs:{"hide-tab-bar":!_vm.loggedIn}},[_vm._v(" "+_vm._s(_vm.$t('not-found.note'))+" "),(!_vm.loggedIn && _vm.$globals.ENV_MOBILE_DEVICE)?_c('AeButton',{attrs:{"slot":"footer","to":{ name: 'intro' }},slot:"footer"},[_vm._v(" "+_vm._s(_vm.$t('not-found.to-home'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }